import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../Icon/Icon'
import { Util } from 'reactstrap'

const CarouselControl = (props) => {
  const { direction, color, onClickHandler, cssModule, directionText, className, iconSize, useCustomArrows } = props
  let icon = props.icon

  if (!icon) {
    icon = direction === 'prev' ? 'chevron-left' : 'chevron-right'
  }

  const anchorClasses = Util.mapToCssModules(classNames(
    className,
    `carousel-control-${direction}`
  ), cssModule)

  const iconClasses = Util.mapToCssModules(classNames(
    useCustomArrows ? `` : `carousel-control-${direction}-icon`
  ), cssModule)

  const screenReaderClasses = Util.mapToCssModules(classNames(
    'sr-only'
  ), cssModule)

  return (
    <a
      className={anchorClasses}
      role='button'
      tabIndex='0'
      onClick={(e) => {
        e.preventDefault()
        onClickHandler()
      }}
    >
      {
        useCustomArrows
          ? <Icon style={color && { color }} className={iconClasses} icon={icon} iconSize={iconSize} />
          : <span className={iconClasses} />
      }
      <span className={screenReaderClasses}>{directionText || direction}</span>
    </a>
  )
}

CarouselControl.propTypes = {
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  cssModule: PropTypes.object,
  directionText: PropTypes.string,
  className: PropTypes.string
}

export default CarouselControl
